export const GET_CONTACT_SETTINGS = "GET_CONTACT_SETTINGS";
export const SET_CONTACT_SETTINGS = "SET_CONTACT_SETTINGS";
export const STORE_CONTACT_SETTINGS = "STORE_CONTACT_SETTINGS";
export const UPDATE_CONTACT_SETTINGS = "UPDATE_CONTACT_SETTINGS";
export const DELETE_CONTACT_SETTINGS = "DELETE_CONTACT_SETTINGS";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
